import {
  GET_ALL_TAGS, SET_ADD_EDIT_TAG_MODAL_STATE,
} from './mutation-types';

export default {
  [GET_ALL_TAGS](state, payload) {
    state.allTags = payload;
  },
  [SET_ADD_EDIT_TAG_MODAL_STATE](state, payload) {
    state.addEditTagModal = payload;
  },
};
